var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5224 3.27344C9.79867 3.27344 6.77242 6.29969 6.77242 10.0234V13.2747C6.77242 13.9609 6.47992 15.0072 6.13117 15.5922L4.83742 17.7409C4.03867 19.0684 4.58992 20.5422 6.05242 21.0372C10.9012 22.6572 16.1324 22.6572 20.9812 21.0372C22.3424 20.5872 22.9387 18.9784 22.1962 17.7409L20.9024 15.5922C20.5649 15.0072 20.2724 13.9609 20.2724 13.2747V10.0234C20.2724 6.31094 17.2349 3.27344 13.5224 3.27344Z",
    stroke: "#9D9DB0",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6039 3.60109C15.2552 3.49984 14.8952 3.42109 14.5239 3.37609C13.4439 3.24109 12.4089 3.31984 11.4414 3.60109C11.7677 2.76859 12.5777 2.18359 13.5227 2.18359C14.4677 2.18359 15.2777 2.76859 15.6039 3.60109Z",
    stroke: "#9D9DB0",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 21.4414C16.8975 23.2977 15.3787 24.8164 13.5225 24.8164C12.6 24.8164 11.745 24.4339 11.1375 23.8264C10.53 23.2189 10.1475 22.3639 10.1475 21.4414",
    stroke: "#9D9DB0",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.56aa5ea3.svg";
export { ForwardRef as ReactComponent };